module.exports = __webpack_public_path__ + "img/670.44e6cdc2.jpg";